<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$emit('closeAddFileResponse')">
            {{$t('com.file.show-interpellation.response-as-file')}}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <label class="esesja-modal__wraper__body__label">{{$t('com.file.send-meeting-regarding.files-label')}}</label>
            <InputFileComponent @change="onFileResponseChange" />
            <section class="checkbox-wrapper" @click="toogleIsSendNotifyToAuthor()">
                <CheckBoxButtonSingleUnchecked
                    :value="1"
                    :id="'response-notify-author'"
                    :checked="isNotifyAuthor"/>
                <label class="checkbox">{{$t('com.file.interpellation.is-send-notify-to-author')}}</label>
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$emit('closeAddFileResponse')">
                {{$t('com.global.cancel')}}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @save="saveFileResponse" :disabled="!responseFile || isLoading">
                {{$t('com.global.send')}}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>

<script>
import InputFileComponent from "../../../../BasicControls/InputFileComponent.vue";
import CheckBoxButtonSingleUnchecked from "../../../../BasicControls/CheckButtonSingleUnchecked.vue";
import uploaderService from "../../../../../services/uploader.service";
import AlertHelper from '@/helpers/alerts.helper.js';

export default {
    name: "AddFileResponseModal",
    emits: ["closeAddFileResponse", "fileResponseAdded"],
    components: {
        InputFileComponent,
        CheckBoxButtonSingleUnchecked,
    },
    props: {
        inter: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            responseFile: null,
            isNotifyAuthor: true,
            isLoading: false,
        };
    },
    methods: {
        toogleIsSendNotifyToAuthor() {
            this.isNotifyAuthor = !this.isNotifyAuthor;
        },
        onFileResponseChange(event) {
            const files = event?.target?.files ?? [];
            this.responseFile = files.length > 0 ? files[0] : null;
        },
        async saveFileResponse() {
            if (!this.responseFile)
                return;

            if (this.responseFile.size > 30000000) {
                this.$swal(AlertHelper.errorAlert(this.$t('com.validation-error.invalid-file-size-info') + " 30MB", this.$t('com.global.error')));
                return;
            }

            try {
                this.isLoading = true;
                const uploadEvent = {
                    target: {
                        files: [this.responseFile],
                    },
                };

                const result = await uploaderService.UploadInterpelationAttachements(this.inter.id, this.inter.lid, uploadEvent, true, this.isNotifyAuthor);
                const fileResponse = result?.[0];
                if (fileResponse && Object.keys(fileResponse).length > 0) {
                    this.$emit("fileResponseAdded", fileResponse);
                    this.$emit("closeAddFileResponse");
                }
            } catch (e) {
                if (e.response?.status == 401)
                    this.$router.push({ name: 'Login' })
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    @use '@/assets/scss/esesja-modal.scss';

    .checkbox {
        font-weight: normal;
        font-size: 16px;
        line-height: 144%;
        color: #333956;
        margin-left: 12px;
        margin-bottom: 0px;
        padding-left: 24px;
        z-index: 0;
        cursor: pointer;
    }

    .checkbox-wrapper {
        display: flex;
        padding: 5px;
        float: left;
        margin-top: 8px;
    }
</style>
